export default __webpack_public_path__ + "static/media/config-router2.9098dc8b.png";